module.exports = __webpack_public_path__ + "media/images/G-10-b88e4d0e45ed32e1399d812cdb36bc21.svg";